// src/components/Banner.jsx
import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from '../context/ThemeContext';

const Banner = ({ title, subtitle, children }) => {
  const { isDarkMode, toggleDarkMode } = useContext(ThemeContext);

  return (
    <div className="bg-white dark:bg-gray-800 transition-colors duration-200">
      <div className="px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-base font-medium text-slate-800 dark:text-slate-200">{title}</h1>
            {subtitle && (
              <>
                <span className="mx-2 text-slate-300 dark:text-slate-600">•</span>
                <p className="text-xs text-slate-500 dark:text-slate-400">{subtitle}</p>
              </>
            )}
          </div>
          <div className="flex items-center space-x-4">
            {children}
            <button
              onClick={toggleDarkMode}
              className="p-1.5 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors duration-200"
              title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
              <FontAwesomeIcon 
                icon={isDarkMode ? faSun : faMoon} 
                className="text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 w-3.5 h-3.5"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
